var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row my-5 text-center"},[_c('div',{staticClass:"col-12"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.logoURL(),"width":"120","alt":"eCourtDate logo"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }